// ===== 临时诊断：捕获子应用启动期被吞掉的报错 =====
// 生产构建里 drop_console=true 会删掉所有 console.*，所以这里用 alert + 写 DOM，
// 这两种方式不会被 terser 删除。定位完成后整段删除即可。
function __reportErr(tag, err) {
  var detail = ''
  try {
    detail = (err && (err.stack || err.message)) || String(err)
  } catch (e) {
    detail = 'unknown error'
  }
  var msg = tag + ' ' + detail
  // 1) 弹窗，最直观
  try { alert(msg) } catch (e) {}
  // 2) 同时写到页面顶部，方便复制完整堆栈
  try {
    var box = document.createElement('pre')
    box.style.cssText = 'position:fixed;z-index:99999;top:0;left:0;right:0;max-height:50vh;overflow:auto;margin:0;padding:12px;background:#fff0f0;color:#c00;font-size:12px;white-space:pre-wrap;border-bottom:2px solid #c00'
    box.textContent = msg
    document.body.appendChild(box)
  } catch (e) {}
}

window.addEventListener('error', function (e) {
  __reportErr('[子应用-全局error]', e.error || e.message)
})
window.addEventListener('unhandledrejection', function (e) {
  __reportErr('[子应用-未处理Promise]', e.reason)
})

// 引入public-path
// import './public-path'
// 引入bootstrap.js
import('./bootstrap.js').catch(function (err) {
  __reportErr('[子应用-bootstrap 执行失败]', err)
})
